import React, { useEffect } from "react";

import { Platform } from "react-native";
import { Input, InputLabel } from "components";
import EntryScreensForm from "./EntryScreensForm";

import { useForm, Controller } from "react-hook-form";
import OtpVerify from "react-native-otp-verify";

import { patterns, strings } from "assets/constants";
import { getFcmToken } from "services";

import { useInsertMobile } from "clients/apis";

import { useNavigation } from "@react-navigation/native";
import { useSetRecoilState } from "recoil";
import { routeParamsAtom } from "stores";

export default function InsertMobile() {
  const { navigate } = useNavigation();
  const insertMobileMut = useInsertMobile();

  const setRouteParams = useSetRecoilState(routeParamsAtom);

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      mobile: "",
      hash_code: "",
      fcm_token: "",
    },
  });

  const _getVerifyCode = () =>
    insertMobileMut.mutate(
      { mobile: getValues().mobile, hash_code: getValues().hash_code },
      { onSuccess: () => navigate("verify_code") }
    );

  useEffect(() => {
    if (Platform.OS === "android") {
      OtpVerify.getHash().then((res) => {
        setValue("hash_code", res[0]);
        setRouteParams((prev) => ({ ...prev, hash_code: res[0] }));
      });
      getFcmToken().then((fcmToken) => {
        setValue("fcm_token", fcmToken);
        setRouteParams((prev) => ({ ...prev, fcm_token: fcmToken }));
      });
    }
  }, [setValue]);

  return (
    <EntryScreensForm
      showHelper
      hideBackButton
      submit={handleSubmit(_getVerifyCode)}
      submitLabel={strings.get_verify_code}
      submitLoading={insertMobileMut?.isLoading}
    >
      <InputLabel label={strings.mobile} />
      <Controller
        control={control}
        name="mobile"
        rules={{
          required: { value: true, message: strings.mobile_is_required },
          pattern: { value: patterns.mobile, message: strings.invalid_mobile },
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <Input
            value={value}
            onChangeText={(input) => {
              onChange(input);
              setRouteParams((prev) => ({ ...prev, mobile: input }));
            }}
            onBlur={onBlur}
            placeholder={strings.insert_mobile}
            icon={{ name: "smartphone" }}
            onSubmitEditing={handleSubmit(_getVerifyCode)}
            error={errors.mobile?.message}
            keyboardType="phone-pad"
            maxLength={11}
          />
        )}
      />
    </EntryScreensForm>
  );
}
